import SearchBarLarge from './SearchBarLarge.jsx';

export default SearchBarLarge;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBarLarge/index.js